import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { WorkspaceRole } from '../../../../api/workspaces/getWorkspaceMembers';
import {
  WorkspaceCode,
  getWorkspaceCode,
} from '../../../../api/workspaces/invite/getWorkspaceCode';

interface UseGetWorkspaceCodeParams<T = WorkspaceCode> {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
  select?: (workspaceCode: WorkspaceCode) => T;
}

export function useGetWorkspaceCode<T = WorkspaceCode>({
  workspaceId,
  workspaceRole,
  select,
}: UseGetWorkspaceCodeParams<T>) {
  return useQuery({
    queryKey: workspaceKeys.codeByWorkspaceRole({
      workspaceId: workspaceId,
      workspaceRole: workspaceRole,
    }),
    queryFn: () =>
      getWorkspaceCode({
        workspaceId: workspaceId,
        workspaceRole: workspaceRole,
      }),
    select,
  });
}
